import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { CampaignResponseDto } from '../dtos/campaign-response.dto';
import { CampaignResponseModel } from '../models/campaign-response.model';
import { GetCampaignInfoByCampaignIdModel } from '../models/get-campaign-info-by-campaign-id.model';
import { mapCampaignResponseDtoToCampaignResponseModel } from '../utils/mapping/mapping.util';

export const getCampaignById: AsyncThunk<
  CampaignResponseModel,
  GetCampaignInfoByCampaignIdModel,
  Record<string, unknown>
> = withMandant<GetCampaignInfoByCampaignIdModel, CampaignResponseModel>(
  Endpoints.CAMPAIGN_BY_CAMPAIGN_ID,
  'campaigns/get-campaign-by-id',
  async ({ args, endpoint }) => {
    const url = createPathParams<'campaignId'>(endpoint, {
      campaignId: args.campaignId,
    });

    const { data }: AxiosResponse<CampaignResponseDto> =
      await axiosInstance.get(url);

    return mapCampaignResponseDtoToCampaignResponseModel(data);
  }
);
